module.exports = __webpack_public_path__ + "r-v3/img/ico_saveSticker_white.c21b5a09.svg";